const { setEnvironment } = require('./../../global/environment');
const addBackToDashboard = (data = {
  environment : "",
  id : "",
  className : "",
  target_id: ""
}) => {
  if(typeof document === 'undefined' || typeof window === 'undefined') return;

  const referrer = document.referrer;
  const invalid_referrer = referrer === "" || referrer === window.location.href;

  if (invalid_referrer || window.self !== window.top) {
    return;
  }

  const url = require("./../../global/url");
  const back_to_dashboard_link = document.createElement("a");
  back_to_dashboard_link.setAttribute("target", "_self");
  back_to_dashboard_link.setAttribute("role", "link");
  back_to_dashboard_link.setAttribute("href", `${url.start}/my-account`);
  back_to_dashboard_link.setAttribute("aria-label", "Back to Dashboard");
  if(data.id) back_to_dashboard_link.setAttribute("id", data.id);
  else back_to_dashboard_link.setAttribute("id", "back_btn");
  //
  if(data.environment) setEnvironment(data.environment);
  if(data.className) back_to_dashboard_link.setAttribute("class", data.className);

  const back_arrow_img = document.createElement("img");
  back_arrow_img.setAttribute("alt", "back button");
  back_arrow_img.setAttribute("width", "30px");
  back_arrow_img.setAttribute("class", "btn_icon");
  back_arrow_img.setAttribute("src", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAR5SURBVHja1JlbbFRVFIa/DqVUoTdI0GAJQo0liDgkYEEFBbklVhsCPCJQk6JQaUhI1DcTHxAkURoukSiC8kC4PRAIVlFoaCBVgiUR5VYNkUtCCFNakIum48P8Z9w9ns6cfZgzIytp9uzJnLW+s7v2uuydF4/HedAkH+CxiifvR8cIYAowARipeX+gBLgB3AJ+A84Ax4BDmgeSS+1nyYvH40GgS4FFwOtANIDtNuBL4AugwxY639LYAOA9oB4o1ncxrd4h4Bet6E2tcomeqQRG6T8yRS8aBd4H1gEr9YwvsVnpOUAjMETzg8BGYD9w1+LF+wGvAHXATH13GVgG7Paz0hEfRgqBz4FdAv4BeA6YDuyxBEa/3wPM0j5old5dwKeyl1IiPnz3G6AWuAM0ABO1oTIhrVqABumvA74FyoJCD5KfTgIuCbYR6M5wBOuW3omy84LsDrKFLpSvRoHTwPPa8WFKm+ycAZ6R/YdsoD8GqoCL8t0LWcobF4BpslulyOILeg7wpjZMjRRkUy4Cr8l+LTA3HXSx8XYrgBM5ytQ/yT7AeiMneEK/AzyqXb0hxyXGBnEMFpcndCmwVJ8bQogSQaJKgz4vFd9/oGuVdpv0hn5lUqrwlIE43iSuhV7Q8zVuslA6WIXP9RBX3OFZ4IYerpgcA/b5VFYAbBNwmEX5PnFFVfYmoV/W+D1wzyfwDsXw1pB9+564AKaa0BM0NvtQ8rAKnhrND2RhUzabnA50pcaf0zw8GvhRpSVyjaYsQDtcI5PtFvC4xvMp3GEZ8IGrdDwKPJ3C2G1Vb35L1j+NxsKUdpMz38iEqNtwy2xgNfCEUdg4LVa1/jItea55h8kZcUF3eiiIAV0WNXgY4nAVmSvdKfBiD/DDwDglnzXAGJd7bPWoX/pYhM3+Pn7nLGqXF3RJL6vdDXymTbdd3QZABbAZ+DvklS41oSNGHYvht73JH8BLwBbNH3FiZ8hSYdhPQp82Qlo6+UuuslbzmixAO1y/mtDHNb7oU0kcWA7sVG8Xtkw2Cqgk9EEjTRZYgL8B9A0ZuMAoM74zoc8r/pZZxt0u4C2z1g1BqsXVBpxzx9yvNNZZKm2xPY+zFIdnq1ei2KyMOEOd8P9BnhXPDSNi9YDuUBOZB3ySo8znbgXXime9+d90g60CrqoEXJJj6CXiuKrap9c6otNobtcAY3MEPBb4SJ/r3YWclws4p5f9gL1AeZaBy2W3UPtsp99jseUK5OUkTjGHZQl4mHJGuezX+z0Wc4r3auCkuoUjBLumsJGo7FTKbrU4fEMDXCNx1dACDCVxJv12CFElIr3HZKdFdq+leiCVxNRxb5GPNaqGzlS9MV76GqV/k+zF0r1lOrlD4iZrHnBFieeofP3VALVHXz33tfy2SnrnAYv99JS2V3JFwLv0vN26rnOJZuAU/95uder3RfLTp1RFTgUGGiF2HfChq6XrVe7nHrFMZ2sLSJza28pJ1RKB7hGDQpsyQqvn3NgOJ3F36PSbN4Hf6Xlj2x7UWBL6QZN/BgBK2hoYMpMxzAAAAABJRU5ErkJggg==");

  const back_button_span = document.createElement("span");
  back_button_span.setAttribute("aria-label", "Back to Dashboard");
  back_button_span.setAttribute("role", "link");
  back_button_span.setAttribute("style", "margin-left: 5px");
  back_button_span.innerHTML = "Dashboard";

  back_to_dashboard_link.append(back_arrow_img);
  back_to_dashboard_link.append(back_button_span);
  if(!document.querySelector("#back_btn")) {
    if(data.target_id) {
      document.querySelector("#" + data.target_id)?.prepend(back_to_dashboard_link);
    } else {
      document.querySelector("body")?.prepend(back_to_dashboard_link);
    }
  }
};

module.exports = addBackToDashboard;